import { logger } from './logger';
import { LogCategory } from './types';

let current: string | undefined;

interface RouteLike {
    name?: string | null;
}

interface RouteCaptureTarget {
    afterEach(hook: (to: RouteLike, from?: RouteLike) => void): unknown;
}

function nameOf(route?: RouteLike): string | undefined {
    return typeof route?.name === 'string' && route.name ? route.name : undefined;
}

// Its own hook: the analytics afterEach returns early on matching paths, as a landing on / has.
export function registerRouteCapture(router: RouteCaptureTarget): void {
    router.afterEach((to, from) => {
        current = nameOf(to);

        // Names only, after the capture, so the record's own route matches what it reports.
        logger.debug(
            LogCategory.NAVIGATION,
            'navigation.route.entered',
            { to: current, from: nameOf(from) },
            'Route entered',
        ).then();
    });
}

export function getCurrentRoute(): string | undefined {
    return current;
}
